export const environment = {

  //  apiBaseUrl: 'http://localhost:5000',
  // apiBaseUrl: 'http://192.168.7.100:5000',
  // signalrUrl: 'http://localhost:9988/notifyhub',

  // pgdev
  imageBaseUrl: 'https://devaedv1image.xenovex.com/',
   apiBaseUrl: 'https://devaedv1api.xenovex.com',
  signalrUrl: 'https://devaedv1signalr.xenovex.com/notifyhub',
  esignUrl: 'https://demosignergateway.emsigner.com/eMsecure/V3_0/Index',

  // apiBaseUrl: 'http://192.168.10.84:5000',

  // apiBaseUrl: 'http://localhost:5000',

  // dev
  // imageBaseUrl: 'https://devaedapi.xenovex.com/images/',
  // apiBaseUrl: 'https://devaedapi.xenovex.com',
  // signalrUrl: 'https://devaedsignalr.xenovex.com/notifyhub',

  // live
  // apiBaseUrl: 'https://mts.aed.tn.gov.in/aedapi',
  // signalrUrl: 'https://mts.aed.tn.gov.in/signalr/notifyhub',
  // imageBaseUrl: 'https://mts.aed.tn.gov.in/images/',
  // esignUrl: 'https://emgateway.emsigner.com/eMsecure/V3_0/Index',


  //security audit
  // imageBaseUrl: 'https://devaedv2image.xenovex.com/',
  // apiBaseUrl: 'https://devaedv2api.xenovex.com',
  // signalrUrl: 'https://devaedv1signalr.xenovex.com/notifyhub',
  // esignUrl: 'https://demosignergateway.emsigner.com/eMsecure/V3_0/Index',


 
  // chatbotUrl: 'http://127.0.0.1:8000',
  // chatbotApiKey: 'qAhowNLxBupaROD6e29auF_gMb3OgUm5tuPS_sumBb4',
  chatbotUrl: '',
  chatbotApiKey: '',
  tokenEndPoint: '/api/token',
  dataInterval: 10000,
  imageFileSize: 2048,
  maxHrsPerDay: 6,
  year: 2018,
  production: false,
  environment: 'Local',
  showEnvironment: true,
  StoppageIntervalSecs: 300,
};
